/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Steps_Col_AiInputs */

const en_dr_steps_col_ai = /** @type {(inputs: Dr_Steps_Col_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI's role`)
};

const id_dr_steps_col_ai = /** @type {(inputs: Dr_Steps_Col_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peran AI`)
};

/**
* | output |
* | --- |
* | "AI's role" |
*
* @param {Dr_Steps_Col_AiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_steps_col_ai = /** @type {((inputs?: Dr_Steps_Col_AiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Steps_Col_AiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_steps_col_ai(inputs)
	return en_dr_steps_col_ai(inputs)
});